// This file is auto-generated. Do not edit manually.

import { DiagnosticFields } from '../DiagnosticFields';

/**
 * Initialize all diagnostic fields to undefined.
 * Used by initLogement to ensure all diagnostic properties are properly initialized.
 */
export function initDiagnosticFields(): DiagnosticFields {
  return {
    chemExtPietonExt: undefined,
    chemExtPietonParking: undefined,
    chemExtPortillonManu: undefined,
    chemExtPortillonAuto: undefined,
    chemExtPortillonTele: undefined,
    chemExtInfo: undefined,
    communHallColectif: undefined,
    communLocalVelo: undefined,
    communPorteVoie: undefined,
    communPorteResidence: undefined,
    communPorteAuto: undefined,
    communPorteTele: undefined,
    communOuvManu: undefined,
    communPorteFourreau: undefined,
    communDispoHaut: undefined,
    communDispoAngle: undefined,
    communDispoSonore: undefined,
    communDispoCamera: undefined,
    communDispoSansFil: undefined,
    communHallSup1m20: undefined,
    communHallSup1m50: undefined,
    communHallEclairageAuto: undefined,
    communHallEclairage90: undefined,
    communAscenseurPalier: undefined,
    communAscenseurBouton: undefined,
    communAscenseurNorme: undefined,
    communAscenseurNormeType3: undefined,
    communAscenseurHori: undefined,
    communAscenseurCommandeVert: undefined,
    communAscenseurMainCourante: undefined,
    communAscenseurMiroir: undefined,
    communBoiteLettre: undefined,
    communBoiteUsage: undefined,
    communBoiteManoeuvre: undefined,
    communBoiteEclairage: undefined,
    communInfo: undefined,
    statioDedie: undefined,
    statioProxi: undefined,
    statioSousSol: undefined,
    statioSousSolBoxe: undefined,
    statioSousSolOuvert: undefined,
    statioSousSolArceaux: undefined,
    statioSousSolMotorise: undefined,
    statioSasInt: undefined,
    statioSasSup1m20: undefined,
    statioSasSup1m50: undefined,
    statioSasOculus: undefined,
    statioSurface: undefined,
    statioSurfaceArceaux: undefined,
    statioSurfaceMotorise: undefined,
    statioVisiteur: undefined,
    statioInfo: undefined,
    entreeLargeur83: undefined,
    entreeLargeur: undefined,
    entreeSerrure: undefined,
    entreePoignee: undefined,
    entreePoigneeRallongee: undefined,
    entreeEspaceManoeuvre: undefined,
    entreeAuto: undefined,
    entreeEclairage: undefined,
    dispositifHauteur130: undefined,
    dispositifHanteur90: undefined,
    dispositifAngle: undefined,
    dispositifFourreauVolets: undefined,
    dispositifVoletElec: undefined,
    dispositifVoletInterrupteur: undefined,
    dispositifVoletTelecommande: undefined,
    dispositifManoeuvreSecours: undefined,
    dispositifPrisesHautes: undefined,
    dispositifPrisesBasses: undefined,
    generalLargeurSup90: undefined,
    generalLargeurEgal120: undefined,
    generalLargeurSup120: undefined,
    generalLargeurPorte83: undefined,
    generalLargeurPorte90: undefined,
    generalPoignetPorte: undefined,
    generalPoigneeRallongee: undefined,
    generalEspaceManoeuvre: undefined,
    generalPlacardAdapte: undefined,
    generalPrisesHautes: undefined,
    generalPrisesBasses: undefined,
    generalInfo: undefined,
    cuisineOuverte: undefined,
    cuisineLargeurPorte83: undefined,
    cuisineLargeurPorte90: undefined,
    cuisinePoignetPorte: undefined,
    cuisinePoigneeRallongee: undefined,
    cuisineEspaceManoeuvre: undefined,
    cuisinePassage: undefined,
    cuisineEspace: undefined,
    cuisineProfondeur: undefined,
    cuisineSiphon: undefined,
    cuisineCuve: undefined,
    cuisinePlanTravail: undefined,
    cuisinePrisesCredence: undefined,
    cuisineInfo: undefined,
    terrasseAcces: undefined,
    terrasseFourreau: undefined,
    terrasseRessaut: undefined,
    terrasseRampe: undefined,
    jardinAcces: undefined,
    jardinRampe: undefined,
    chambreLargeurPorte80: undefined,
    chambreLargeurPorte90: undefined,
    chambrePoignetPorte: undefined,
    chambrePoigneeRallongee: undefined,
    chambreEspaceManoeuvre: undefined,
    chambreDiametre: undefined,
    chambrePassage: undefined,
    chambrePlacardAdapte: undefined,
    chambrePrisesHautes: undefined,
    chambrePrisesBasses: undefined,
    chambreInfo: undefined,
    chambresLargeurPorte80: undefined,
    chambresLargeurPorte90: undefined,
    chambresPoignetPorte: undefined,
    chambresPoigneeRallongee: undefined,
    chambresEspaceManoeuvre: undefined,
    chambresRetournement: undefined,
    chambresPrisesHautes: undefined,
    chambresPrisesBasses: undefined,
    chambresInfo: undefined,
    bainLargeurPorte80: undefined,
    bainLargeurPorte90: undefined,
    bainPoignetPorte: undefined,
    bainPoigneeRallongee: undefined,
    bainEspaceManoeuvre: undefined,
    salleBainEspace: undefined,
    doucheCloisons: undefined,
    bainPrisesHautes: undefined,
    bainPrisesBasses: undefined,
    bainInfo: undefined,
    doucheReceveurSansRessaut: undefined,
    doucheItalienne: undefined,
    doucheItalienneOk: undefined,
    doucheReceveurEncastre: undefined,
    doucheReceveurEncastreOk: undefined,
    doucheBarreAppui: undefined,
    doucheSiege: undefined,
    doucheParois: undefined,
    lavaboUsage: undefined,
    lavaboHauteurReglable: undefined,
    lavaboHauteur: undefined,
    lavaboLibreSous: undefined,
    lavaboProfondeur: undefined,
    lavaboSiphon: undefined,
    wcSepare: undefined,
    wcLargeurPorte80: undefined,
    wcLargeurPorte90: undefined,
    wcPoignetPorte: undefined,
    wcPoigneeRallongee: undefined,
    wcEspaceManoeuvre: undefined,
    wcEspace: undefined,
    wcCloison: undefined,
    wcHauteur: undefined,
    wcSuspendu: undefined,
    wcBarreAppui: undefined,
    wcPrisesHautes: undefined,
    wcPrisesBasses: undefined,
    logementInfo: undefined,
  };
}
